import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import searchReducer from "./slices/searchSlice";
import bookingReducer from "./slices/bookingSlice";

// journeyDate se PERSISTUJE (refresh na /placanje je gubio izabrani datum);
// validacija „datum u prošlosti → danas" je u searchSlice na persist/REHYDRATE.
// journeyDateAdjusted je jednokratni UI flag — ne persistuje se.
const searchPersistConfig = {
    key: "search",
    storage,
    blacklist: ["returnDate", "tripResults", "isLoading", "error", "journeyDateAdjusted"],
};

const rootReducer = combineReducers({
    search: persistReducer(searchPersistConfig, searchReducer),
    booking: bookingReducer,
});

const persistConfig = {
    key: "busgo-client",
    storage,
    whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
            },
        }),
});

export const persistor = persistStore(store);
